module.exports = __webpack_public_path__ + "img/new-dfod.45548ae2.svg";